<template>
  <div>
    <div class="head">
      <img class="logoImg" src="../assets/img/logo.png" />
      <div class="point animated" v-bind:class="{ rubberBand: isEffect }">
        所持コイン <span>{{ this.$store.state.points }}</span
        >枚
      </div>
    </div>
    <div class="container">
      <div class="row content">
        <div class="one-half column">
          <img class="gachaImage" src="../assets/img/gachabody.png" />
        </div>
        <div class="one-half column buttons">
          <button class="gacha" v-bind:disabled="isPush" @click="startGame()">
            1回（100枚）まわす
          </button>
          <button @click="kakuritsuShow()">提供割合</button>
          <button @click="back()">戻る</button>
        </div>
      </div>
      <transition appear name="zoom">
        <div v-if="modalShow" class="modalWindow">
          <div class="row">
            <table class="u-full-width">
              <tbody>
                <tr>
                  <th colspan="2">1等 (2%)</th>
                </tr>
                <tr>
                  <td>
                    <img
                      class="prize"
                      src="../assets/img/prize/takoW_2.png"
                      alt="たこさんウィンナ"
                    />
                  </td>
                  <td>たこさんウィンナ (2%)</td>
                </tr>
                <tr>
                  <th colspan="2">2等 (4%)</th>
                </tr>
                <tr>
                  <td>
                    <img
                      class="prize"
                      src="../assets/img/prize/jinbei_2.png"
                      alt="じんべいざめ"
                    />
                  </td>
                  <td>じんべいざめ (2%)</td>
                </tr>
                <tr>
                  <td>
                    <img
                      class="prize"
                      src="../assets/img/prize/manbou_2.png"
                      alt="マンボウ"
                    />
                  </td>
                  <td>マンボウ (2%)</td>
                </tr>
                <tr>
                  <th colspan="2">3等 (10%)</th>
                </tr>
                <tr>
                  <td>
                    <img
                      class="prize"
                      src="../assets/img/prize/kumanomi_2.png"
                      alt="くまのみ"
                    />
                  </td>
                  <td>くまのみ (5%)</td>
                </tr>
                <tr>
                  <td>
                    <img
                      class="prize"
                      src="../assets/img/prize/kurione_2.png"
                      alt="クリオネ"
                    />
                  </td>
                  <td>クリオネ (5%)</td>
                </tr>
                <tr>
                  <th colspan="2">4等 (14%)</th>
                </tr>
                <tr>
                  <td>
                    <img
                      class="prize"
                      src="../assets/img/prize/kurage_2.png"
                      alt="くらげ"
                    />
                  </td>
                  <td>くらげ (7%)</td>
                </tr>
                <tr>
                  <td>
                    <img
                      class="prize"
                      src="../assets/img/prize/tako_2.png"
                      alt="たこ"
                    />
                  </td>
                  <td>たこ (7%)</td>
                </tr>
                <tr>
                  <th colspan="2">5等 (30%)</th>
                </tr>
                <tr>
                  <td>
                    <img
                      class="prize"
                      src="../assets/img/prize/fugu_2.png"
                      alt="フグ"
                    />
                  </td>
                  <td>フグ (15%)</td>
                </tr>
                <tr>
                  <td>
                    <img
                      class="prize"
                      src="../assets/img/prize/kame_2.png"
                      alt="かめ"
                    />
                  </td>
                  <td>かめ (15%)</td>
                </tr>
                <tr>
                  <th colspan="2">6等 (40%)</th>
                </tr>
                <tr>
                  <td>
                    <img
                      class="prize"
                      src="../assets/img/prize/saba_2.png"
                      alt="さば"
                    />
                  </td>
                  <td>さば (20%)</td>
                </tr>
                <tr>
                  <td>
                    <img
                      class="prize"
                      src="../assets/img/prize/kozakana_2.png"
                      alt="こざかな"
                    />
                  </td>
                  <td>こざかな (20%)</td>
                </tr>
              </tbody>
            </table>
            <button @click="cancel()">閉じる</button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "gacha",
  data() {
    return {
      rate: 0,
      items: [
        ["takoW"], //1等 49回まで0%、50回から20%
        ["jinbei", "manbou"], //2等 29回まで0%、30回～49回まで20％、50回から25%
        ["kumanomi", "kurione"], //3等 29回まで10%、30~49回まで20%、50回から15%
        ["kurage", "tako"], //4等 29回まで20%、30回から15%
        ["kame", "fugu"], //5等 49回まで30％、50回から10％
        ["saba", "kozakana"], //6等 29回まで40%、30回から15%
      ],
      modalShow: false,
      isPush: false,
    };
  },
  created: function () {
    var self = this;
    clearInterval(self.$store.state.routeNext);
  },
  methods: {
    kakuritsuShow: function () {
      this.modalShow = true;
    },
    cancel: function () {
      this.modalShow = false;
    },
    back: function () {
      this.$router.push({ name: "home" });
    },
    startGame: function () {
      this.isPush = true;
      var self = this;
      if (self.$store.state.points <= 0) {
        self.$router.push({ name: "home" });
      } else {
        self.$store.state.points = self.$store.state.points - 100;
        self.getRate();
        var num = Math.floor(Math.random() * self.items[self.rate - 1].length);
        self.$store.state.getPrize = self.items[self.rate - 1][num];
        var param = {
          classNum: self.$store.state.classNum,
          userId: self.$store.state.id,
          prize: self.$store.state.getPrize,
          stName: self.$store.state.stName,
        };
        axios.post(self.$store.state.APIbase + "api/prize", param).then(() => {
          var param2 = {
            points: self.$store.state.points,
            gachaTimes: self.$store.state.gachaTimes + 1,
          };
          axios
            .put(
              self.$store.state.APIbase + "api/user/" + self.$store.state.id,
              param2
            )
            .then((res) => {
              self.$store.state.points = res.data["points"];
              self.$store.state.gachaTimes = res.data["gachaTimes"];
              self.$router.push({ name: "game" });
            })
            .catch(() => {});
        });
      }
    },
    //レイトの計算
    getRate: function () {
      var self = this;
      var random = Math.floor(Math.random() * 100) + 1;
      if (self.$store.state.rateReg) {
        //確率調整あり
        var times = self.$store.state.gachaTimes;
        if (times < 30) {
          switch (true) {
            case random <= 10:
              self.rate = 3;
              break;
            case random <= 30:
              self.rate = 4;
              break;
            case random <= 60:
              self.rate = 5;
              break;
            case random <= 100:
              self.rate = 6;
              break;
          }
        } else if (times < 50) {
          switch (true) {
            case random <= 20:
              self.rate = 2;
              break;
            case random <= 40:
              self.rate = 3;
              break;
            case random <= 55:
              self.rate = 4;
              break;
            case random <= 85:
              self.rate = 5;
              break;
            case random <= 100:
              self.rate = 6;
              break;
          }
        } else {
          switch (true) {
            case random <= 20:
              self.rate = 1;
              break;
            case random <= 45:
              self.rate = 2;
              break;
            case random <= 60:
              self.rate = 3;
              break;
            case random <= 75:
              self.rate = 4;
              break;
            case random <= 85:
              self.rate = 5;
              break;
            case random <= 100:
              self.rate = 6;
              break;
          }
        }
      } else {
        //確率調整なし
        switch (true) {
          case random <= 2:
            self.rate = 1;
            break;
          case random <= 6:
            self.rate = 2;
            break;
          case random <= 16:
            self.rate = 3;
            break;
          case random <= 30:
            self.rate = 4;
            break;
          case random <= 60:
            self.rate = 5;
            break;
          case random <= 100:
            self.rate = 6;
            break;
        }
      }
    },
  },
};
</script>

<style scoped>
.head {
  width: 100%;
  background: #4690cf;
  transition: height 1s;
  box-shadow: 0px -4px 2px rgba(0, 0, 0, 0.5) inset;
  height: 70px;
}
.logoImg {
  width: 90px;
  padding-left: 20px;
  margin: 0;
  margin-bottom: -20px;
}
.point {
  float: right;
  position: relative;
  top: 0px;
  right: 20px;
  color: white;
}
.point span {
  font-size: 5.2rem;
}
.content {
  text-align: center;
}
.gachaImage {
  width: 100%;
}
@media (min-width: 700px) {
  .buttons {
    margin-top: 100px;
  }
}
@media (max-width: 700px) {
  .gachaImage {
    width: 50%;
  }
}
@media (max-width: 400px) {
  .gachaImage {
    width: 80%;
  }
}
.gacha {
  font-size: 1.8rem;
  border: 2px solid #545454;
}
.gacha:hover {
  background: #bfe1ff;
}
button {
  width: 100%;
}
.prize {
  position: relative;
  width: 100px;
}
.modalWindow {
  width: 300px;
  height: 360px;
  margin-top: -200px;
  margin-left: -180px;
  background: white;
  position: fixed;
  top: 50%;
  left: 50%;
  font-size: 1rem;
  padding: 20px;
  border-radius: 5px;
  overflow: scroll;
}
.zoom-enter-active {
  animation: zoom-in 0.5s ease-out;
}
.zoom-leave-active {
  animation: zoom-out 0.5s ease-out;
}
@keyframes zoom-in {
  0% {
    transform: scale(0.01);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes zoom-out {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.01);
  }
}

th {
  background: #4690cf;
  color: #fff;
  padding: 5px;
  padding-left: 10px;
  font-size: 1.2rem;
  font-weight: bold;
}
</style>